import {HStack} from '@chakra-ui/react';
import React, {useState} from 'react';
import {CheckboxMultiSelect, NestedCheckboxMultiSelect, DateRangeDropdown} from "@/components";
import {useLanguage} from "@/contexts/languageContext";

export const EntityListFilter = ({options, onChange, selectProps = {}, selectedItems = {}, ...props}) => {
    const { t } = useLanguage();
    const [filters, setFilters] = useState(Object.keys(options).reduce((acc, key) => {
        return {...acc, [key]: (selectedItems?.[key] ?? [])};
    }, {}));

    const getBodyComponent = (key) => {
        if (options[key]?.type === 'dateRange') return DateRangeDropdown;
        if (options[key]?.nested === true) return NestedCheckboxMultiSelect;
        return CheckboxMultiSelect;
    };

    return (
        <HStack
            w="100%"
            justify="flex-start"
            style={{
                position: 'relative',
                zIndex: 99
            }} {...props}>
            {
                Object.keys(options).map((key) => {
                    const Body = getBodyComponent(key);
                    return <Body
                        {...selectProps}
                        key={`filter-${key}`}
                        items={options[key].items}
                        selectedItems={filters[key]}
                        onChange={(e) => setFilters((prevState) => {
                            /** Remove all filters that are empty
                             * ex: {user: [], deleted: []}
                             * */
                            const newValue = Object.fromEntries(
                                    Object.entries({...prevState, [key]: e})
                                        .filter(([_, value]) => {
                                            if (options[key]?.type === 'dateRange') {
                                                return value !== null && (value?.min || value?.max);
                                            }
                                            return (value ?? []).length > 0;
                                        })
                                )
                            onChange(newValue);
                            return newValue;
                        })}
                        getSelectedText={(selectedItems) => {
                            return `${selectedItems.length} ${t('states.selected', {count: selectedItems.length} )}`
                        }}
                        placeholder={options[key].placeholder}
                        dropdownProps={{
                            w: 'auto',
                            left: 0
                        }}
                    />
                })
            }
        </HStack>
    );
};

export default EntityListFilter;
